/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

 import React from "react";
 import { Redirect, Switch, Route } from "react-router-dom";
// import swal from "sweetalert";
 // import { shallowEqual, useSelector } from "react-redux";
 import {Layout} from "../_metronic/layout";
 import BasePage from "./BasePage";
 import { Logout, AuthPage } from "./modules/Auth";
 import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
 import Maintenance from "./modules/Auth/pages/Maintenance";

const IS_MAINTENANCE = process.env.REACT_APP_IS_MAINTENANCE === "true";
//  function alertFunc() {
//     swal({
//         title: "Sesi anda telah selesai, silahkan login kembali!",
//         // text: "Lanjut simpan target masa studi Profesi?",
//         icon: "warning",
//         // buttons: true,
//         dangerMode: false,
//       }).then((willDelete)=>{
//         if(willDelete){
//             window.localStorage.clear();
//             // window.location.href="auth/login";
//             window.location.reload();
//         }else{
//           swal("Anda tidak melanjutkan proses!");
//         }
//       })
//   }

function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)

    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }

    const item = JSON.parse(itemStr)
    const now = new Date()

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        return null
    }
    return item.value
}
 export function Routes() {
     // const {isAuthorized} = useSelector(
     //     ({auth}) => ({
     //         isAuthorized: auth.user !== null,
     //     }),
     //     shallowEqual
     // );
 
    //  const token = localStorage.getItem("login")
     const token = getWithExpiry("statlogin")
     let loggedIn = true
     if (token === null) {
       loggedIn = false
     }
    //  if (loggedIn === true){
    //      setTimeout(alertFunc, 
    //         // 6000
    //         1800 * 1000
    //         )
    //  }
     if (IS_MAINTENANCE) {
         return (
             <Switch>
                 <Route path="/maintenance" component={Maintenance} />
                 <Redirect to="/maintenance" />
             </Switch>
         );
     }

     return (
         <Switch>
             {!loggedIn ? (
                 <Route>
                     <AuthPage />
                 </Route>
             ) : (
               
                 <Redirect from="/auth" to="/"/>
             )}

             <Route path="/error" component={ErrorsPage}/>
             <Route path="/logout" component={Logout}/>

             {!loggedIn ? (
                 <Redirect to="/auth/login"/>
             ) : (
                 <Layout>
                     <BasePage/>
                 </Layout>
             )}
         </Switch>
     );
 }